/**
 * BankCleared — écritures marquées à la main « passées en banque » (sans ligne de relevé) : liste et retrait du marquage.
 */
import { useState } from "react";
import { Undo2 } from "lucide-react";
import { api } from "@/api";
import { toast } from "@/lib/toast";
import { errMsg, money } from "../../comptabilite/_shared";

export default function BankCleared({ base, accountId, items, onChanged }) {
  const [busy, setBusy] = useState(null);
  const unclear = async (id) => {
    setBusy(id);
    try { await api.post(`${base}/bank/gl/unclear`, { account_id: accountId, entry_ids: [id] }); toast.success("Marquage retiré — écriture de nouveau en circulation"); onChanged(); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(null); }
  };
  if (!items?.length) return <p className="px-3 py-2 text-xs text-slate-400 bg-white border-t" data-testid="bank-cleared-empty">Aucune écriture marquée à la main.</p>;
  return (
    <div className="max-h-56 overflow-y-auto bg-white border-t" data-testid="bank-cleared-list">
      <table className="w-full text-xs">
        <tbody className="divide-y">
          {items.map((e) => (
            <tr key={e.entry_id} data-testid={`bank-cleared-${e.entry_id}`}>
              <td className="px-3 py-1.5 w-24 whitespace-nowrap text-slate-600">{e.date}</td>
              <td className="px-2 py-1.5 w-16 text-slate-500">{e.no ? `N° ${e.no}` : <span className="text-orange-700">GL att.</span>}</td>
              <td className="px-2 py-1.5 text-slate-800 truncate max-w-[400px]" title={e.memo}>{e.memo}{e.note && <span className="text-slate-400"> · {e.note}</span>}</td>
              <td className={`px-3 py-1.5 text-right font-mono font-semibold w-28 ${e.amount < 0 ? "text-rose-700" : "text-emerald-700"}`}>{money(e.amount)}</td>
              <td className="px-2 py-1.5 w-28 text-right">
                <button onClick={() => unclear(e.entry_id)} disabled={busy === e.entry_id} className="text-teal-700 hover:underline inline-flex items-center gap-1 disabled:opacity-50" data-testid={`bank-unclear-${e.entry_id}`}><Undo2 className="w-3 h-3" /> Annuler</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
